import YooptaEditor, {
  Blocks,
  createYooptaEditor,
  generateId,
  YooptaBlockData,
} from "@yoopta/editor";
import Blockquote from "@yoopta/blockquote";
import Paragraph from "@yoopta/paragraph";
import Image from "@yoopta/image";
import {
  Bold,
  Italic,
  CodeMark,
  Strike,
  Underline,
  Highlight,
} from "@yoopta/marks";
import Lists from "@yoopta/lists";
import Link from "@yoopta/link";
import Video from "@yoopta/video";
import File from "@yoopta/file";
import Code from "@yoopta/code";
import { useEffect, useMemo } from "react";
import s from "./SlackChat.module.scss";
import { SlackTopToolbar } from "./SlackTopToolbar";
import { HeadingOne, HeadingTwo, HeadingThree } from "@yoopta/headings";
const plugins = [
  HeadingOne,
  HeadingTwo,
  HeadingThree,
  Paragraph.extend({
    options: {
      HTMLAttributes: {
        className: s.chatText,
      },
    },
  }),
  Blockquote.extend({
    options: {
      HTMLAttributes: {
        className: s.chatText,
      },
    },
  }),
  Image,
  Video,
  File,
  Lists.BulletedList.extend({
    options: {
      HTMLAttributes: {
        className: s.chatText,
      },
    },
  }),
  Lists.NumberedList.extend({
    options: {
      HTMLAttributes: {
        className: s.chatText,
      },
    },
  }),
  Link,
  Code,
];

const MARKS = [Bold, Italic, CodeMark, Strike, Underline, Highlight];

const YooptaReadOnly = ({ onChange = () => {}, initValue = {} }) => {
  const editor = useMemo(() => createYooptaEditor(), []);

  return (
    <YooptaEditor
      editor={editor}
      plugins={plugins}
      marks={MARKS}
      className={s.editor}
      value={initValue}
      placeholder="Escribe aqui"
      /*     selectionBoxRoot={false} */
      width="100%"
      onChange={onChange}
      readOnly={true}
    />
  );
};

export { YooptaReadOnly };
